import {useEffect, useState} from "react"

import {documentTypes} from "./api/useDocuments"

export const loadFromTypes = {
    document: {
        // sales
        salesOrder: {id: `salesOrder`, type: `document`},
        deliveryOrder: {id: `deliveryOrder`, type: `document`},
        salesInvoice: {id: `salesInvoice`, type: `document`},
        cashSales: {id: `cashSales`, type: `document`},
        salesDebitNote: {id: `salesDebitNote`, type: `document`},
        salesCreditNote: {id: `salesCreditNote`, type: `document`},
        replacementDelivery: {id: `replacementDelivery`, type: `document`},

        // retail
        retailCashSales: {id: `retailCashSales`, type: `document`},
        retailPrescription: {id: `retailPrescription`, type: `document`},

        // purchase
        purchaseOrder: {id: `purchaseOrder`, type: `document`},
        purchaseReturn: {id: `purchaseReturn`, type: `document`},
        purchaseInvoice: {id: `purchaseInvoice`, type: `document`},

        // warehouse
        itemReceive: {id: `itemReceive`, type: `document`},
        itemTransfer: {id: `itemTransfer`, type: `document`},
        itemRelocate: {id: `itemRelocate`, type: `document`},
        itemTransform: {id: `itemTransform`, type: `document`},
        itemIssue: {id: `itemIssue`, type: `document`},
        itemAdjustment: {id: `itemAdjustment`, type: `document`},
        stockTake: {id: `stockTake`, type: `document`},
        transferReturn: {id: `transferReturn`, type: `document`},
        transferRequisition: {id: `transferRequisition`, type: `document`},
        pickOrder: {id: `pickOrder`, type: `document`},

        // logistic
        tripOrder: {id: `tripOrder`, type: `document`},

    }
}

export const loadFromScopes = {
    document: {
        // sales
        salesOrder: {
            salesOrder: {id: 'salesOrder', value: documentTypes.salesOrder, title: `salesOrders`},
            salesInvoice: {id: 'salesInvoice', value: documentTypes.salesInvoice, title: `salesInvoices`},
            deliveryOrder: {id: 'deliveryOrder', value: documentTypes.deliveryOrder, title: `deliveryOrders`},
            cashSales: {id: 'cashSales', value: documentTypes.cashSales, title: `cashSales`},
            salesDebitNote: {id: 'salesDebitNote', value: documentTypes.salesDebitNote, title: `salesDebitNotes`},
            salesCreditNote: {id: 'salesCreditNote', value: documentTypes.salesCreditNote, title: `salesCreditNotes`},
            replacementDelivery: {id: 'replacementDelivery', value: documentTypes.replacementDelivery, title: `replacementDelivery`},
        },
        salesInvoice: {
            salesOrder: {id: 'salesOrder', value: documentTypes.salesOrder, title: `salesOrders`},
            salesInvoice: {id: 'salesInvoice', value: documentTypes.salesInvoice, title: `salesInvoices`},
            deliveryOrder: {id: 'deliveryOrder', value: documentTypes.deliveryOrder, title: `deliveryOrders`},
            cashSales: {id: 'cashSales', value: documentTypes.cashSales, title: `cashSales`},
            salesDebitNote: {id: 'salesDebitNote', value: documentTypes.salesDebitNote, title: `salesDebitNotes`},
            salesCreditNote: {id: 'salesCreditNote', value: documentTypes.salesCreditNote, title: `salesCreditNotes`},
            replacementDelivery: {id: 'replacementDelivery', value: documentTypes.replacementDelivery, title: `replacementDelivery`},
        },
        deliveryOrder: {
            salesOrder: {id: 'salesOrder', value: documentTypes.salesOrder, title: `salesOrders`},
            salesInvoice: {id: 'salesInvoice', value: documentTypes.salesInvoice, title: `salesInvoices`},
            deliveryOrder: {id: 'deliveryOrder', value: documentTypes.deliveryOrder, title: `deliveryOrders`},
            cashSales: {id: 'cashSales', value: documentTypes.cashSales, title: `cashSales`},
            salesDebitNote: {id: 'salesDebitNote', value: documentTypes.salesDebitNote, title: `salesDebitNotes`},
            salesCreditNote: {id: 'salesCreditNote', value: documentTypes.salesCreditNote, title: `salesCreditNotes`},
            replacementDelivery: {id: 'replacementDelivery', value: documentTypes.replacementDelivery, title: `replacementDelivery`},
        },
        cashSales: {
            salesOrder: {id: 'salesOrder', value: documentTypes.salesOrder, title: `salesOrders`},
            salesInvoice: {id: 'salesInvoice', value: documentTypes.salesInvoice, title: `salesInvoices`},
            deliveryOrder: {id: 'deliveryOrder', value: documentTypes.deliveryOrder, title: `deliveryOrders`},
            cashSales: {id: 'cashSales', value: documentTypes.cashSales, title: `cashSales`},
            salesDebitNote: {id: 'salesDebitNote', value: documentTypes.salesDebitNote, title: `salesDebitNotes`},
            salesCreditNote: {id: 'salesCreditNote', value: documentTypes.salesCreditNote, title: `salesCreditNotes`},
            replacementDelivery: {id: 'replacementDelivery', value: documentTypes.replacementDelivery, title: `replacementDelivery`},
        },
        salesDebitNote: {
            salesOrder: {id: 'salesOrder', value: documentTypes.salesOrder, title: `salesOrders`},
            salesInvoice: {id: 'salesInvoice', value: documentTypes.salesInvoice, title: `salesInvoices`},
            deliveryOrder: {id: 'deliveryOrder', value: documentTypes.deliveryOrder, title: `deliveryOrders`},
            cashSales: {id: 'cashSales', value: documentTypes.cashSales, title: `cashSales`},
            salesDebitNote: {id: 'salesDebitNote', value: documentTypes.salesDebitNote, title: `salesDebitNotes`},
            salesCreditNote: {id: 'salesCreditNote', value: documentTypes.salesCreditNote, title: `salesCreditNotes`},
            replacementDelivery: {id: 'replacementDelivery', value: documentTypes.replacementDelivery, title: `replacementDelivery`},
        },
        salesCreditNote: {
            salesOrder: {id: 'salesOrder', value: documentTypes.salesOrder, title: `salesOrders`},
            salesInvoice: {id: 'salesInvoice', value: documentTypes.salesInvoice, title: `salesInvoices`},
            deliveryOrder: {id: 'deliveryOrder', value: documentTypes.deliveryOrder, title: `deliveryOrders`},
            cashSales: {id: 'cashSales', value: documentTypes.cashSales, title: `cashSales`},
            salesDebitNote: {id: 'salesDebitNote', value: documentTypes.salesDebitNote, title: `salesDebitNotes`},
            salesCreditNote: {id: 'salesCreditNote', value: documentTypes.salesCreditNote, title: `salesCreditNotes`},
            replacementDelivery: {id: 'replacementDelivery', value: documentTypes.replacementDelivery, title: `replacementDelivery`},
        },
        replacementDelivery: {
            salesOrder: {id: 'salesOrder', value: documentTypes.salesOrder, title: `salesOrders`},
            salesInvoice: {id: 'salesInvoice', value: documentTypes.salesInvoice, title: `salesInvoices`},
            deliveryOrder: {id: 'deliveryOrder', value: documentTypes.deliveryOrder, title: `deliveryOrders`},
            cashSales: {id: 'cashSales', value: documentTypes.cashSales, title: `cashSales`},
            salesDebitNote: {id: 'salesDebitNote', value: documentTypes.salesDebitNote, title: `salesDebitNotes`},
            salesCreditNote: {id: 'salesCreditNote', value: documentTypes.salesCreditNote, title: `salesCreditNotes`},
            replacementDelivery: {id: 'replacementDelivery', value: documentTypes.replacementDelivery, title: `replacementDelivery`},
        },

        // retail
        retailCashSales: {
            retailCashSales: {id: 'retailCashSales', value: documentTypes.retailCashSales, title: `retailCashSales`},
            retailPrescription: {id: 'retailPrescription', value: documentTypes.retailPrescription, title: `retailPrescriptions`},
        },
        retailPrescription: {
            retailCashSales: {id: 'retailCashSales', value: documentTypes.retailCashSales, title: `retailCashSales`},
            retailPrescription: {id: 'retailPrescription', value: documentTypes.retailPrescription, title: `retailPrescriptions`},
        },

        // purchase
        purchaseOrder: {
            purchaseOrder: {id: 'purchaseOrder', value: documentTypes.purchaseOrder, title: `purchaseOrders`},
            purchaseReturn: {id: 'purchaseReturn', value: documentTypes.purchaseReturn, title: `purchaseReturns`},
            purchaseInvoice: {id: 'purchaseInvoice', value: documentTypes.purchaseInvoice, title: `purchaseInvoices`},
        },
        purchaseReturn: {
            purchaseOrder: {id: 'purchaseOrder', value: documentTypes.purchaseOrder, title: `purchaseOrders`},
            purchaseReturn: {id: 'purchaseReturn', value: documentTypes.purchaseReturn, title: `purchaseReturns`},
            purchaseInvoice: {id: 'purchaseInvoice', value: documentTypes.purchaseInvoice, title: `purchaseInvoices`},
        },
        purchaseInvoice: {
            purchaseOrder: {id: 'purchaseOrder', value: documentTypes.purchaseOrder, title: `purchaseOrders`},
            purchaseReturn: {id: 'purchaseReturn', value: documentTypes.purchaseReturn, title: `purchaseReturns`},
            purchaseInvoice: {id: 'purchaseInvoice', value: documentTypes.purchaseInvoice, title: `purchaseInvoices`},
        },

        // warehouse
        itemReceive: {
            itemReceive: {id: 'itemReceive', value: documentTypes.itemReceive, title: `itemReceives`},
            itemTransfer: {id: 'itemTransfer', value: documentTypes.itemTransfer, title: `itemTransfers`},
            itemRelocate: {id: 'itemRelocate', value: documentTypes.itemRelocate, title: `itemRelocates`},
            itemTransform: {id: 'itemTransform', value: documentTypes.itemTransform, title: `itemTransforms`},
            itemIssue: {id: 'itemIssue', value: documentTypes.itemIssue, title: `itemIssues`},
            itemAdjustment: {id: 'itemAdjustment', value: documentTypes.itemAdjustment, title: `itemAdjustments`},
            stockTake: {id: 'stockTake', value: documentTypes.stockTake, title: `stockTakes`},
            transferReturn: {id: 'transferReturn', value: documentTypes.transferReturn, title: `transferReturns`},
            transferRequisition: {id: 'transferRequisition', value: documentTypes.transferRequisition, title: `transferRequisitions`},
            purchaseOrder: {id: 'purchaseOrder', value: documentTypes.purchaseOrder, title: `purchaseOrders`},
            purchaseInvoice: {id: 'purchaseInvoice', value: documentTypes.purchaseInvoice, title: `purchaseInvoices`},

        },
        itemTransfer: {
            itemReceive: {id: 'itemReceive', value: documentTypes.itemReceive, title: `itemReceives`},
            itemTransfer: {id: 'itemTransfer', value: documentTypes.itemTransfer, title: `itemTransfers`},
            itemRelocate: {id: 'itemRelocate', value: documentTypes.itemRelocate, title: `itemRelocates`},
            itemTransform: {id: 'itemTransform', value: documentTypes.itemTransform, title: `itemTransforms`},
            itemIssue: {id: 'itemIssue', value: documentTypes.itemIssue, title: `itemIssues`},
            itemAdjustment: {id: 'itemAdjustment', value: documentTypes.itemAdjustment, title: `itemAdjustments`},
            stockTake: {id: 'stockTake', value: documentTypes.stockTake, title: `stockTakes`},
            transferReturn: {id: 'transferReturn', value: documentTypes.transferReturn, title: `transferReturns`},
            transferRequisition: {id: 'transferRequisition', value: documentTypes.transferRequisition, title: `transferRequisitions`},
        },
        itemRelocate: {
            itemReceive: {id: 'itemReceive', value: documentTypes.itemReceive, title: `itemReceives`},
            itemTransfer: {id: 'itemTransfer', value: documentTypes.itemTransfer, title: `itemTransfers`},
            itemRelocate: {id: 'itemRelocate', value: documentTypes.itemRelocate, title: `itemRelocates`},
            itemTransform: {id: 'itemTransform', value: documentTypes.itemTransform, title: `itemTransforms`},
            itemIssue: {id: 'itemIssue', value: documentTypes.itemIssue, title: `itemIssues`},
            itemAdjustment: {id: 'itemAdjustment', value: documentTypes.itemAdjustment, title: `itemAdjustments`},
            stockTake: {id: 'stockTake', value: documentTypes.stockTake, title: `stockTakes`},
            transferReturn: {id: 'transferReturn', value: documentTypes.transferReturn, title: `transferReturns`},
            transferRequisition: {id: 'transferRequisition', value: documentTypes.transferRequisition, title: `transferRequisitions`},
        },
        itemTransform: {
            itemReceive: {id: 'itemReceive', value: documentTypes.itemReceive, title: `itemReceives`},
            itemTransfer: {id: 'itemTransfer', value: documentTypes.itemTransfer, title: `itemTransfers`},
            itemRelocate: {id: 'itemRelocate', value: documentTypes.itemRelocate, title: `itemRelocates`},
            itemTransform: {id: 'itemTransform', value: documentTypes.itemTransform, title: `itemTransforms`},
            itemIssue: {id: 'itemIssue', value: documentTypes.itemIssue, title: `itemIssues`},
            itemAdjustment: {id: 'itemAdjustment', value: documentTypes.itemAdjustment, title: `itemAdjustments`},
            stockTake: {id: 'stockTake', value: documentTypes.stockTake, title: `stockTakes`},
            transferReturn: {id: 'transferReturn', value: documentTypes.transferReturn, title: `transferReturns`},
            transferRequisition: {id: 'transferRequisition', value: documentTypes.transferRequisition, title: `transferRequisitions`},
        },
        itemIssue: {
            itemReceive: {id: 'itemReceive', value: documentTypes.itemReceive, title: `itemReceives`},
            itemTransfer: {id: 'itemTransfer', value: documentTypes.itemTransfer, title: `itemTransfers`},
            itemRelocate: {id: 'itemRelocate', value: documentTypes.itemRelocate, title: `itemRelocates`},
            itemTransform: {id: 'itemTransform', value: documentTypes.itemTransform, title: `itemTransforms`},
            itemIssue: {id: 'itemIssue', value: documentTypes.itemIssue, title: `itemIssues`},
            itemAdjustment: {id: 'itemAdjustment', value: documentTypes.itemAdjustment, title: `itemAdjustments`},
            stockTake: {id: 'stockTake', value: documentTypes.stockTake, title: `stockTakes`},
            transferReturn: {id: 'transferReturn', value: documentTypes.transferReturn, title: `transferReturns`},
            transferRequisition: {id: 'transferRequisition', value: documentTypes.transferRequisition, title: `transferRequisitions`},
        },
        itemAdjustment: {
            itemReceive: {id: 'itemReceive', value: documentTypes.itemReceive, title: `itemReceives`},
            itemTransfer: {id: 'itemTransfer', value: documentTypes.itemTransfer, title: `itemTransfers`},
            itemRelocate: {id: 'itemRelocate', value: documentTypes.itemRelocate, title: `itemRelocates`},
            itemTransform: {id: 'itemTransform', value: documentTypes.itemTransform, title: `itemTransforms`},
            itemIssue: {id: 'itemIssue', value: documentTypes.itemIssue, title: `itemIssues`},
            itemAdjustment: {id: 'itemAdjustment', value: documentTypes.itemAdjustment, title: `itemAdjustments`},
            stockTake: {id: 'stockTake', value: documentTypes.stockTake, title: `stockTakes`},
            transferReturn: {id: 'transferReturn', value: documentTypes.transferReturn, title: `transferReturns`},
            transferRequisition: {id: 'transferRequisition', value: documentTypes.transferRequisition, title: `transferRequisitions`},
        },
        stockTake: {
            itemReceive: {id: 'itemReceive', value: documentTypes.itemReceive, title: `itemReceives`},
            itemTransfer: {id: 'itemTransfer', value: documentTypes.itemTransfer, title: `itemTransfers`},
            itemRelocate: {id: 'itemRelocate', value: documentTypes.itemRelocate, title: `itemRelocates`},
            itemTransform: {id: 'itemTransform', value: documentTypes.itemTransform, title: `itemTransforms`},
            itemIssue: {id: 'itemIssue', value: documentTypes.itemIssue, title: `itemIssues`},
            itemAdjustment: {id: 'itemAdjustment', value: documentTypes.itemAdjustment, title: `itemAdjustments`},
            stockTake: {id: 'stockTake', value: documentTypes.stockTake, title: `stockTakes`},
            transferReturn: {id: 'transferReturn', value: documentTypes.transferReturn, title: `transferReturns`},
            transferRequisition: {id: 'transferRequisition', value: documentTypes.transferRequisition, title: `transferRequisitions`},
        },
        transferReturn: {
            itemReceive: {id: 'itemReceive', value: documentTypes.itemReceive, title: `itemReceives`},
            itemTransfer: {id: 'itemTransfer', value: documentTypes.itemTransfer, title: `itemTransfers`},
            itemRelocate: {id: 'itemRelocate', value: documentTypes.itemRelocate, title: `itemRelocates`},
            itemTransform: {id: 'itemTransform', value: documentTypes.itemTransform, title: `itemTransforms`},
            itemIssue: {id: 'itemIssue', value: documentTypes.itemIssue, title: `itemIssues`},
            itemAdjustment: {id: 'itemAdjustment', value: documentTypes.itemAdjustment, title: `itemAdjustments`},
            stockTake: {id: 'stockTake', value: documentTypes.stockTake, title: `stockTakes`},
            transferReturn: {id: 'transferReturn', value: documentTypes.transferReturn, title: `transferReturns`},
            transferRequisition: {id: 'transferRequisition', value: documentTypes.transferRequisition, title: `transferRequisitions`},
        },
        transferRequisition: {
            itemReceive: {id: 'itemReceive', value: documentTypes.itemReceive, title: `itemReceives`},
            itemTransfer: {id: 'itemTransfer', value: documentTypes.itemTransfer, title: `itemTransfers`},
            itemRelocate: {id: 'itemRelocate', value: documentTypes.itemRelocate, title: `itemRelocates`},
            itemTransform: {id: 'itemTransform', value: documentTypes.itemTransform, title: `itemTransforms`},
            itemIssue: {id: 'itemIssue', value: documentTypes.itemIssue, title: `itemIssues`},
            itemAdjustment: {id: 'itemAdjustment', value: documentTypes.itemAdjustment, title: `itemAdjustments`},
            stockTake: {id: 'stockTake', value: documentTypes.stockTake, title: `stockTakes`},
            transferReturn: {id: 'transferReturn', value: documentTypes.transferReturn, title: `transferReturns`},
            transferRequisition: {id: 'transferRequisition', value: documentTypes.transferRequisition, title: `transferRequisitions`},
        },
        pickOrder: {
            pickOrder: {id: 'pickOrder', value: documentTypes.pickOrder, title: `pickOrders`},
        },

        // Logistic
        tripOrder: {
            tripOrder: {id: 'tripOrder', value: documentTypes.tripOrder, title: `tripOrders`},
        },
    }
}

// console.log('loadFromScopes', loadFromScopes)

export function useLoadFrom(_loadFromId, _loadFromType) {

    const [loadFromId, setLoadFromId] = useState(_loadFromId)
    const [loadFromType, setLoadFromType] = useState(_loadFromType)

    const getAvailableOptions = (props) => {

        // console.log('loadFromId', loadFromId)
        // console.log('loadFromType', loadFromType)

        return loadFromScopes[loadFromType][loadFromId]

    }

    return {
        getAvailableOptions
    }
}